import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import back from "../../../assets/back.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import InputField from "../../../components/form/inputField/inputField";
import {
  fetchDistrictList,
  fetchStateList,
} from "../../../redux/actions/commonActions";
import { useDispatch } from "react-redux";
import ErrorMsg from "../../../components/form/errorMsg";
import { fieldForceHeadQuarterCreate } from "../../../redux/actions/fieldForceAction";
import CreatedPopUp from "../../../components/popups/CreatedPopUp";
import InputCapitalField from "../../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceHeadQuarterCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [created, setCreated] = useState(false);
  const [showCreatedMsg, setShowCreatedMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  useEffect(() => {
    dispatch(fetchStateList(onGetStateSuccess, onGetStateError));
  }, []);
  const onGetStateSuccess = (data) => {
    let newArr = data.data.data.states.map((ele) => ({
      value: ele.id,
      label: ele.name,
    }));
    setStateOptions(newArr);
    console.log();
  };
  const onGetStateError = (err) => {
    console.log(err);
  };

  useEffect(() => {
    if (selectedState !== null) {
      dispatch(
        fetchDistrictList(
          selectedState,
          onGetDistrictSuccess,
          onGetDistrictError
        )
      );
    }
  }, [selectedState]);
  console.log(selectedState);

  const onGetDistrictSuccess = (data) => {
    let newArr = data.data.data.districts.map((ele) => ({
      value: ele.id,
      label: ele.name,
    }));
    setDistrictOptions(newArr);
  };
  const onGetDistrictError = (err) => {
    console.log(err);
  };
  const initialValues = {
    name: "",
    state_id: "",
    districts: [],
  };
  const clearFunc = (setFieldValue) => {
    setFieldValue("name", "");
    setFieldValue("state_id", "");
    setFieldValue("districts", []);
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    state_id: Yup.string().trim().required("Required"),
    districts: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
  });
  const onSubmit = (values) => {
    dispatch(fieldForceHeadQuarterCreate(values, onSuccess, onError));
  };
  const onSuccess = (data) => {
    setShowCreatedMsg(data?.data?.message);
    setCreated(true);
    const timeOutFnc = () => {
      setCreated(false);
      navigate("/field-force/head-quarter");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/head-quarter",
      breadcrumb: " / field force / head quarter",
    },
    {
      path: "/field-force/head-quarter/create",
      breadcrumb: " / create",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form className="">
                <div className="search-container d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <AdminButton
                      background="#E7E5FF"
                      width="100px"
                      type="button"
                      onClick={() => clearFunc(setFieldValue)}
                    >
                      CLEAR
                    </AdminButton>
                    <AdminButton
                      background="#7065e4"
                      color="white"
                      width="100px"
                      type="submit"
                    >
                      <span className="m-2">SAVE</span>
                    </AdminButton>
                  </div>
                </div>

                <div className="form-width ms-4 ps-3 py-1 mt-4">
                  <div className="my-2">
                    <InputCapitalField
                      setFieldValue={setFieldValue}
                      id={"name"}
                      label={"Head Quarters Name"}
                      labelColor={"color_262c3d"}
                      type={"text"}
                      placeholder={"Enter head quarters name"}
                      name={"name"}
                      value={values?.name}
                    />
                  </div>

                  <div className="w-100">
                    <label className="w-100 color_262c3d fn_Nunito fs_14">
                      State
                    </label>
                    <Field name={"state_id"}>
                      {({ field, meta }) => (
                        <Select
                          {...field}
                          options={stateOptions}
                          styles={customStyles}
                          placeholder={"Select state"}
                          value={stateOptions.filter(
                            (s) => s.value == values.state_id
                          )}
                          onChange={(selected) => {
                            setSelectedState(selected?.value);
                            setFieldValue("districts", []);
                            setFieldValue("state_id", selected?.value);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMsg name="state_id" />
                  </div>
                  <div className="w-100">
                    <label className="w-100 color_262c3d fn_Nunito fs_14">
                      District
                    </label>
                    <Field name={"districts"}>
                      {({ form, Field }) => (
                        <Select
                          isMulti
                          options={districtOptions}
                          styles={customStyles}
                          {...Field}
                          placeholder={"Enter your district"}
                          id="districts"
                          value={districtOptions.filter((o1) =>
                            values?.districts?.some((o2) => o2 == o1.value)
                          )}
                          onChange={(selectedOption) => {
                            let newArr = values.districts;
                            form.setFieldValue(
                              "districts",
                              selectedOption
                                ? selectedOption.map((item) => item.value)
                                : []
                            );
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMsg name="districts" />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <CreatedPopUp
            show={created}
            handelClose={() => setCreated(false)}
            title={showCreatedMsg}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default FieldForceHeadQuarterCreate;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    // height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
